module.exports = __webpack_public_path__ + "img/ch-logo.673332fd.jpg";